<template>
	<div>
		<div id="download">
		

			<h1>Get started with Money Guided</h1>
			<img style="margin-top: 20px; width: 50%; max-width: 200px; margin-bottom: 20px" src="https://s3.eu-west-2.amazonaws.com/content.sysodev.link/909ad9d0-Warwickshire-Police-Logo-Square.png" />
			
			<!-- <div class="alert alert-danger"><strong>We're experiencing high sign-up volumes</strong> - 
				Thank you for your interest in joining Money Guided! Due to an exceptionally high number of sign-ups, we’re experiencing temporary delays. We’re working hard to get everything running smoothly again, and we appreciate your patience.</div>

			<div style="clear:both; height: 700px"></div> -->
			
			
			<p>Our intention is to help people develop a more positive relationship with their money. 
				Developed by our team of finance experts and clinical psychologists Money Guided provides the insights and tools to help you 
					make the right decisions at the right time.</p>


			<h2>Step 1. Get access</h2>
			<p>To get started, complete the form below.  Please enter your name, your personal or work email address and your force number without prefix.</p>
			<p>We will use this data to confirm your eligibility for accessing the Money Guided app.</p>
			<b-form>
				<b-form-group id="input-group-2" label="Your Name:" label-for="input-2">
					<b-form-input id="input-2" placeholder="Joe Bloggs" required v-model="generate.name"></b-form-input>
				</b-form-group>

				<b-form-group id="input-group-2" label="Email:" label-for="input-2" description="We'll never share your email with anyone else.">
					<b-form-input id="input-2" type="email" placeholder="joe.bloggs@warwickshire.police.uk" required v-model="generate.email"></b-form-input>
				</b-form-group>
				<b-form-group id="input-group-1" label="Force No.:" label-for="input-1" >
					<b-form-input id="input-1" placeholder="xxxx" required v-model="generate.number"></b-form-input>
				</b-form-group>
				<div>{{message}}</div>
				<b-button class="btn-lg mt-4"  @click="getAccess">Get Access</b-button> 
			</b-form>

			<div style="clear:both; height: 25px"></div>

			<h2>Step 2. Download Money Guided</h2>

			<b-row class="mt-4 centered">
				
				<b-col>
					<div class="dl">
						<h2>Android</h2>
						<p class="small centered">Mobile and Tablet</p>
						<a href="https://play.google.com/store/apps/details?id=com.syso.moneyguided"><img :src="require('../assets/android.png')" /></a>
					</div>
				</b-col>
				
				<b-col>
					<div class="dl">
						<h2>iOS</h2>
						<p class="small centered">Mobile</p>
						<a href="https://apps.apple.com/gb/app/money-guided/id6443701567"><img :src="require('../assets/ios.svg')" /></a>
					</div>
				</b-col>

			</b-row>
			
			<div style="clear:both; height: 25px"></div>
			<h2>Step 3. Sign Up in App</h2>
			<p>Please note, this page only allows you <i>permission</i> to signup using the App.  It does not create your account.  You must choose "Continue" when opening the app, and <strong>not</strong> "Sign in"</p>
			<div style="clear:both; height: 25px"></div>

		</div>


	</div>
	
</template>

<script>

export default {
	components: {  },
	name: "Download",
	data: function() {
		return {
			generate: {
				name: null,
				email: null,
				number: null
			},
			message: ''
		}
	},
	methods:
	{
		getAccess: function() {
			this.message = '';
			if (this.generate.email) {
				this.generate.email = this.generate.email.trim().toLowerCase();
			}
			else {
				this.message = 'Please enter your email address.';
				return;
			}
			if (this.generate.name) {
				this.generate.name = this.generate.name.trim();
			}
			else {
				this.message = 'Please enter your name.';
				return;
			}
			if (this.generate.email == '') {
				this.message = 'Please enter your email address.';
				return;
			}
			if (this.generate.name == '') {
				this.message = 'Please enter your name.';
				return;
			}
			if (this.generate.number == null || this.generate.number == '') {
				this.message = 'Please enter your force number without any prefixes.';
				return;
			}
			var invite = {
				email: this.generate.email,
				name: this.generate.name,
				employerName: 'Warwickshire Police',
				number: this.generate.number,
				sendEmail: true,
				authCode: this.$route.query.c,
				gatewayKey: this.generate.number
			}
			this.$http.post(this.$route.meta.api + "/Employees/Invites", invite).then((response) => {
				if (response.data) {
					this.message = 'Thanks ' + this.generate.name + 
						'. You can now create your Money Guided account in the App! Please proceed to step 2! When asked for your work email address in the app please enter ' + 
						this.generate.email;
				}
			}).catch(() => {
				this.message = 'Sorry, we could not validate you.  Please check your benevolent member number and try again.  Please note, if you have just joined the force, it may take a few days for your details to be available.';
			});
		}
	},
	mounted: function() {
		if (!this.$route.query.c) {
			this.$router.push({ path: '/dl' });
		}
	},
}
</script>

<style scoped>

	#download {
		padding-top: 130px;
		p--adding-bottom: 130px;
		width: 60%;
		min-width: 300px;
		margin-left: auto;
		margin-right: auto;
	}

	.dl
	{
		background-color: #281c3bea;
		border-radius: 3%;
		padding: 50px;
		padding-top: 30px;
		margin: 10px;
		max-width: 400px;
		color: #ffffff;
	}

	.dl img{
		margin-top: 30px;
		width: 100%;
		max-height: 80px;
	}

	.centered {
		text-align: center !important;
	}

	h1 {
		font-size: 27px;
		font-weight: bold;
		margin-bottom: 10px;
		text-align: left;
	}
	h1 {
		text-align: center;
	}
	h2 {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 5px;
		margin-top: 30px;
	}
	.row {
		text-align: left;
	}

	p {
		text-align: left;
	}

	@media all and (max-width: 767px)
	{
		#download,p,h1 {
			text-align: center;
		}
	}

</style>

<style>
	.feature-carousel {
		p--adding-top: 60px;
		padding-bottom: 60px;
		background-color: #ffffff !important;
	}

	.btn {
		width: 100% !important;
		max-width: 400px !important;
		font-size: 14px !important;
		height: unset !important;
	}
</style>